import axios from 'axios'
import { useMutation, UseMutationResult, useQuery, UseQueryResult } from '@tanstack/react-query'

import { CmdTypes, RequestData, ResponseHeader } from 'src/types/type'
import { forwardPlaystore, guid } from 'src/utils/Common'
import { ServerUrl } from 'src/utils/APIPath';
import { addApiBreadcrumb } from 'src/utils/sentry/breadcrumb'
import { captureServerError, captureUnexpectedErrCode } from 'src/utils/sentry/api'
import { SUCCESS_ERR_CODES } from 'src/types/errcode'

const requestID = guid()

const useAPI = (cmdType: keyof CmdTypes): any => {
  const cmdTypeList: CmdTypes = {
    sendcaptchaexpress: '010001', // 인증번호 요청
    sendotpverfy: '010002', // 가입 요청
    CheckMvnoMember: '010006', // KT 알뜰폰 회원 확인
    CheckVulnerableMember: '010015', // KT 취약계층 확인
  }

  const createHttpData: any = (
    cmdType: keyof CmdTypes,
    requestBody: unknown,
  ): RequestData<unknown> => {
    return {
      Header: {
        CmdType: cmdTypeList[cmdType],
        RequestID: requestID,
      },
      Body: requestBody,
    }
  }
  const requestWCRS = async <T>(CmdType: keyof CmdTypes, ReqBody?: T): Promise<any> => {
    const httpData = createHttpData(CmdType, ReqBody)
    const sentryCmdType = httpData.Header.CmdType

    addApiBreadcrumb('request', { cmdType: sentryCmdType })

    return await axios
      .post(ServerUrl, httpData, { withCredentials: true })
      .then(async (response) => {
        const { Header, Body } = response?.data
        if (!SUCCESS_ERR_CODES.has(Header?.ErrCode)) {
          addApiBreadcrumb('response', {
            cmdType: sentryCmdType,
            errCode: Header?.ErrCode,
            errMsg: Header?.ErrMsg,
          })
          captureUnexpectedErrCode(Header)
        }
        return await handleError(Header, Body)
      })
      .catch((error) => {
        captureServerError(error, sentryCmdType)
        return error
      })
  }
  const handleError = async (Header: ResponseHeader, Body: any): Promise<any> => {
    if (Header?.ErrCode === 0) {
      return { Header, Body }
    }
    switch (Header?.ErrCode) {
      case '00000000': {
        return { Header, Body }
      }
      case '10020001' : { //기존 가입자 이벤트
        alert('이미 서비스에 가입되어 있습니다.')
        forwardPlaystore();
        // window.close()
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({'event': 'already_signup'});
        break
      }
      default:
        alert(
          Header?.ErrMsg ??
            `(${Header?.CmdType}) ${Header?.ErrCode} : 알 수 없는 오류가 발생했습니다.`,
        )
        return { Header, Body }
    }
  }

  // react-query
  const useSetQuery = <T, E = unknown>(data: unknown): UseQueryResult<T | undefined, E> => {
    return useQuery([cmdType, data ?? {}], async () => await requestWCRS(cmdType, data))
  }
  type UseSetMutationReturnType<T> = UseMutationResult<T, Error, unknown>

  const useSetMutation = <T>(data: unknown): UseSetMutationReturnType<T> => {
    return useMutation([cmdType, data], async () => await requestWCRS(cmdType, data))
  }
  return {
    useSetQuery,
    useSetMutation,
  }
}
export default useAPI
